module.exports = __webpack_public_path__ + "link.17aa637eae6675691ecd70c40b7018fb.svg";